export default "__VITE_ASSET__Bb_Dydmu__"